module.exports = __webpack_public_path__ + "static/media/Used Cat Articulated Trucks - Toromont Cat.d04f9681.jpg";